import React from "react";
import Typography from "@material-ui/core/Typography";
import {observacionesResources} from "../endpoints";
import MaterialTable from "material-table";
import tableicons from "../tableicons";
import Button from "@material-ui/core/Button";
import DialogAgregarEditarObservacion from "../components/DialogAgregarEditarObservacion";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import SnackbarAlert from "../components/SnackbarAlert";
import DialogEliminar from "../components/DialogEliminar";
import useToken from "../useToken";
import { Redirect } from "react-router-dom";

class Observaciones extends React.Component{
    constructor(props) {
        super(props);
        this.state= {
            cargando: true,
            datos: [],
            agregar: false,
            title: "",
            openSnack: false,
            severity: null,
            message: null,
            editar: false,
            eliminar:false,
            observacion: "",
            agregar_obs_usuario:false
        }
    }

    obtenerObservaciones = () =>{
        this.setState({openSnack:false, severity: null, message:null})
        observacionesResources.getObservaciones().then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.status_code === 200){
                this.setState({cargando:false,datos:result.observaciones})
            }
            else if (result.status_code === 401){
                this.setState({cargando:false,openSnack:true, severity:result.severity, message:result.message})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
        });
    }

    componentDidMount() {
        const verifyFolio = useToken.verifyToken()
        if(!verifyFolio){
            this.props.history.push('/inventarios');
        }
        else{
            this.obtenerObservaciones();
        }
    }

    handleClose = () =>{
        this.setState({agregar:false,editar:false,eliminar:false,agregar_obs_usuario:false})
    }

    para_editar_obs = (rowData) =>{
       this.setState({editar:true,observacion:rowData,title:"Editar observación general"})
    }

    refrescar = (estado,severity) =>{
        this.setState({agregar:false,agregar_obs_usuario:false,editar:false,eliminar:false, openSnack:false, severity: null, message:null})
        if(severity ==="success"){
            this.obtenerObservaciones()
        }
        this.setState({openSnack:true, severity:severity, message:estado})
    }

    eliminarObservacion = (row) =>{
        this.setState({eliminar:true, title: "Eliminar observación general", content: "Esta acción es irreversible. Está seguro que desea eliminar la observación?", observacion:row})
    }

    render() {
        const verifyFolio = useToken.verifyToken()

        if(!verifyFolio){
            return <Redirect to="/inventarios"/>
        }
        else{
            return(
                <div>
                    <Typography variant="h4" gutterBottom>
                        Observaciones
                    </Typography>
                    <div style={{display: 'flex',justifyContent: 'end'}}>
                        <Button size="large" variant="contained" color="primary" onClick={()=>this.setState({agregar_obs_usuario:true, title:"Agregar observación de usuario"})}>
                            Agregar obs. de usuario
                        </Button>
                        <Button style={{marginLeft:'5px'}} size="large" variant="contained" color="primary" onClick={()=>this.setState({agregar:true, title:"Agregar observación general"})}>
                            Agregar obs. general
                        </Button>
                    </div>
                    <br/>
                    <MaterialTable
                        localization={{
                            toolbar: {
                                searchPlaceholder: 'Buscar'
                            },
                            header: {
                                actions: 'Acciones'
                            },
                            body:{
                                emptyDataSourceMessage: 'No hay datos para mostrar'
                            }
                        }}
                        isLoading={this.state.cargando}
                        options={{
                            pageSize: 25,
                            pageSizeOptions: [10, 25, 50, 100],
                            actionsColumnIndex: -1,
                            rowStyle: rowData => ({
                                backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' : '#FFF'
                            }),
                            searchFieldStyle: {
                                width: "auto",
                            },
                            padding: "dense"
                        }}
                        icons={tableicons}
                        title={""}
                        data={this.state.datos}
                        columns={[
                            { title: 'Cód. Usuario', field:'usuario' },
                            { title: 'Fecha y hora', field: 'timestamp',
                                render: rowData => new Date(Date.parse(new Date(rowData.timestamp) + ' UTC')).toLocaleString(),
                                customFilterAndSearch: ((term, rowData) => new Date(Date.parse(new Date(rowData.timestamp) + ' UTC')).toLocaleString().indexOf(term) !== -1),
                                cellStyle: {
                                    width: 200,
                                    maxWidth: 200,
                                },
                                headerStyle: {
                                    width: 200,
                                    maxWidth: 200
                                }},
                            { title: 'Detalle', field: 'texto',
                                cellStyle: {
                                    width: 1250,
                                    maxWidth: 1250,
                                },
                                headerStyle: {
                                    width: 1250,
                                    maxWidth: 1250
                            }},
                            {title:'Prioridad', field:'prioridad_desc'}
                        ]}
                        actions={[
                            {
                                icon:  () => <CreateIcon style={{fontSize:27, margin:4}}/>,
                                tooltip: 'Editar ubicación',
                                onClick: (event, rowData) => this.para_editar_obs(rowData),
                            },
                            {
                                icon:  () => <DeleteIcon style={{fontSize:27, margin:4}}/>,
                                tooltip: 'Eliminar ubicación',
                                onClick: (event, rowData) => this.eliminarObservacion(rowData),
                            }
                        ]}
                        onRowClick={(event, rowData) => this.setState({selectedRow: rowData.tableData.id})}
                    />
                    {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}

                    {this.state.agregar && <DialogAgregarEditarObservacion observacion={null} refrescar={this.refrescar} usuario={false} handleClose={this.handleClose} title={this.state.title}/>}

                    {this.state.editar && <DialogAgregarEditarObservacion observacion={this.state.observacion} usuario={false}  refrescar={this.refrescar} handleClose={this.handleClose} title={this.state.title}/>}

                    {this.state.agregar_obs_usuario && <DialogAgregarEditarObservacion observacion={null} usuario={true}  refrescar={this.refrescar} handleClose={this.handleClose} title={this.state.title}/>}

                    {this.state.eliminar? <DialogEliminar origen={"Observacion"} refrescar={this.refrescar} id={this.state.observacion.id} handleClose={this.handleClose} content={this.state.content} title={this.state.title}  />:null}

                </div>
            )
        }
    }
}

export default Observaciones;